import { buildQueryString } from './url';

export const getRouteWithParams = ({
  route,
  params,
  queryParams,
  hash,
}: {
  route: string;
  params?: Record<string, string>;
  queryParams?: Record<string, string>;
  hash?: string;
}) => {
  const queryParametersString = buildQueryString(queryParams);
  const hashString = hash ? `#${hash}` : '';

  return (
    route
      .split('/')
      .map((part) => {
        if (!part.startsWith(':')) {
          return part;
        }

        const paramKey = part.substring(1);
        const paramValue = params?.[paramKey];

        if (!paramValue) {
          console.error(`No parameter provided for ${paramKey}`);
        }

        return paramValue;
      })
      .join('/') +
    queryParametersString +
    hashString
  );
};
